import React from 'react';

const Footer = ({ language }) => {
  const translations = {
    tr: {
      phone: "+32 485 93 59 29",
      address: "Garage Ozcanlar - Doornzele Dries 79, 9940 Evergem, Belçika",
      rights: "© 2025 Garage Ozcanlar. Tüm hakları saklıdır.",
      hours: "Açılış Saatleri:",
      monday: "Pazartesi: 09:00–18:30",
      tuesday: "Salı: 09:00–18:30",
      wednesday: "Çarşamba: 09:00–18:30",
      thursday: "Perşembe: 09:00–18:30",
      friday: "Cuma: 09:00–18:30",
      saturday: "Cumartesi: 09:00–17:00",
      sunday: "Pazar: Kapalı"
    },
    fr: {
      phone: "+32 485 93 59 29",
      address: "Garage Ozcanlar - Doornzele Dries 79, 9940 Evergem, Belgique",
      rights: "© 2025 Garage Ozcanlar. Tous droits réservés.",
      hours: "Horaires d'ouverture:",
      monday: "Lundi: 09:00–18:30",
      tuesday: "Mardi: 09:00–18:30",
      wednesday: "Mercredi: 09:00–18:30",
      thursday: "Jeudi: 09:00–18:30",
      friday: "Vendredi: 09:00–18:30",
      saturday: "Samedi: 09:00–17:00",
      sunday: "Dimanche: Fermé"
    },
    nl: {
      phone: "+32 485 93 59 29",
      address: "Garage Ozcanlar - Doornzele Dries 79, 9940 Evergem, België",
      rights: "© 2025 Garage Ozcanlar. Alle rechten voorbehouden.",
      hours: "Openingstijden:",
      monday: "Maandag: 09:00–18:30",
      tuesday: "Dinsdag: 09:00–18:30",
      wednesday: "Woensdag: 09:00–18:30",
      thursday: "Donderdag: 09:00–18:30",
      friday: "Vrijdag: 09:00–18:30",
      saturday: "Zaterdag: 09:00–17:00",
      sunday: "Zondag: Gesloten"
    }
  };

  const t = translations[language] || translations.tr;

  return (
    <footer className="footer-area">
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="footer-info">
                <h4>{t.address}</h4>
                <p>Dépannage: {t.phone}</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footer-hours">
                <h4>{t.hours}</h4>
                <ul style={{ listStyle: 'none', padding: 0, fontSize: '14px' }}>
                  <li>{t.monday}</li>
                  <li>{t.tuesday}</li>
                  <li>{t.wednesday}</li>
                  <li>{t.thursday}</li>
                  <li>{t.friday}</li>
                  <li>{t.saturday}</li>
                  <li style={{ color: '#ff6b35' }}>{t.sunday}</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footer-social text-right">
                <a href="https://www.facebook.com/ozcanlar.ozcan.77/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="copyright">
                <p>{t.rights}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;